import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsentDocumentType, ConsentDocumentTypeParam, UserConsentStatus } from 'src/app/models/user/user.model';
import { UserService } from 'src/app/models/user/user.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';

@Component({
  selector: 'app-policy-terms',
  templateUrl: './policy-terms.component.html',
  styleUrls: ['./policy-terms.component.scss']
})
export class PolicyTermsComponent implements OnInit {

  constructor(public translate: TranslateFirebaseService,
              private userService: UserService,
              private router: Router) { }

  ngOnInit(): void {
  }

  get touLink(): string {
    return this.userService.touLink;
  }

  get privacyLink(): string {
    return this.userService.privacyLink;
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

  accept(): void {
    this.userService.touDocs.forEach((doc: UserConsentStatus) => {
      if (doc.document === ConsentDocumentType.TERMS_OF_USE) {
        this.userService.updateConditions(ConsentDocumentTypeParam.TERMS_OF_USE)
          .subscribe(() => {});
      } else if (doc.document === ConsentDocumentType.PRIVACY_POLICY) {
        this.userService.updateConditions(ConsentDocumentTypeParam.PRIVACY_POLICY)
          .subscribe(result => {
            console.log(result);
          });
      }
    });
    if (this.userService.upsUser.backofficeRole != null) {
      this.router.navigateByUrl('/backoffice');
    } else {
      this.router.navigateByUrl('/app');
    }
  }
}
